/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Vb365BackupWindowSettings } from './vb365BackupWindowSettings';


export interface Vb365BackupJobSchedulePolicy { 
    /**
     * Type of a job schedule policy.
     */
    schedulePolicyType: Vb365BackupJobSchedulePolicySchedulePolicyType;
    /**
     * Type of a time interval for a periodically running job.
     */
    periodicallyEvery?: Vb365BackupJobSchedulePolicyPeriodicallyEvery | null;
    /**
     * Days when the daily job runs.
     */
    dailyType?: Vb365BackupJobSchedulePolicyDailyType | null;
    /**
     * Indicates whether a job schedule is enabled.
     */
    scheduleEnabled?: boolean;
    /**
     * Indicates whether backup window is enabled.
     */
    backupWindowEnabled?: boolean;
    /**
     * Backup window settings.
     */
    backupWindowSettings?: Vb365BackupWindowSettings | null;
    /**
     * Backup window settings for periodically running jobs.
     */
    periodicallyWindowSettings?: Vb365BackupWindowSettings | null;
    /**
     * Indicates whether backup window is enabled for periodically running jobs.
     */
    periodicallyWindowEnabled?: boolean | null;
    /**
     * Number of minutes that must be skipped after specified job starting time.
     */
    periodicallyOffsetMinutes?: number | null;
    /**
     * Time of day when job must start in the `hh:mm` format.
     */
    dailyTime?: string | null;
    /**
     * Indicates whether job retry is enabled.
     */
    retryEnabled?: boolean;
    /**
     * Number of allowed retries.
     */
    retryNumber?: number | null;
    /**
     * Time interval between job retries.
     */
    retryWaitInterval?: number | null;
}
export enum Vb365BackupJobSchedulePolicySchedulePolicyType {
    Unknown = 'Unknown',
    Periodically = 'Periodically',
    Daily = 'Daily',
    ManualOnly = 'ManualOnly'
};
export enum Vb365BackupJobSchedulePolicyPeriodicallyEvery {
    Unknown = 'Unknown',
    Minutes5 = 'Minutes5',
    Minutes10 = 'Minutes10',
    Minutes15 = 'Minutes15',
    Minutes30 = 'Minutes30',
    Hours1 = 'Hours1',
    Hours2 = 'Hours2',
    Hours4 = 'Hours4',
    Hours8 = 'Hours8'
};
export enum Vb365BackupJobSchedulePolicyDailyType {
    Unknown = 'Unknown',
    Everyday = 'Everyday',
    Workdays = 'Workdays',
    Weekends = 'Weekends',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday',
    Sunday = 'Sunday'
};



